import { useState } from 'react'
import { TCompletedMedEvent } from '../generic-followup-form.type'
import { useFollowupFormContext } from '../generic-followup-form.component'
import FollowupMedEventForm from './med-event-form.component'
import { TMedEventUI } from 'src/types/med-event'
import { DeletedMedEventCard, MedEventCard } from './med-event-card.component'

export interface Props {
  completedMedEvent: TCompletedMedEvent
  onDelete: (medEventToDelete: TCompletedMedEvent) => void
}

const CompletedMedEventCard = ({ completedMedEvent, onDelete }: Props) => {
  const { selectNewMedEventToComplete } = useFollowupFormContext()

  const eventDateTime = (completedMedEvent.date && new Date(completedMedEvent.date).getTime()) || 0
  const isMedEventInThePast = Date.now() > eventDateTime

  const [isEdited, setIsEdited] = useState<boolean>(false)

  if (!completedMedEvent.medEventUI) {
    return <DeletedMedEventCard completedMedEvent={completedMedEvent} onDelete={onDelete} />
  }

  if (isMedEventInThePast) {
    return <MedEventCard completedMedEvent={completedMedEvent} onDelete={onDelete} />
  }
  return isEdited ? (
    <FollowupMedEventForm
      onCloseCallback={() => {
        setIsEdited(false)
      }}
      completedMedEvent={completedMedEvent}
      isEditing={true}
    />
  ) : (
    <MedEventCard
      completedMedEvent={completedMedEvent}
      onDelete={onDelete}
      onClickOnCard={async () => {
        const isSelected = selectNewMedEventToComplete?.(completedMedEvent.medEventUI as TMedEventUI)
        if (isSelected) {
          setIsEdited(true)
        }
      }}
    />
  )
}

export default CompletedMedEventCard
